import { render, staticRenderFns } from "./RegistrationClosed.vue?vue&type=template&id=e772b93c&scoped=true&"
import script from "./RegistrationClosed.vue?vue&type=script&lang=js&"
export * from "./RegistrationClosed.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationClosed.vue?vue&type=style&index=0&id=e772b93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e772b93c",
  null
  
)

export default component.exports